<template>
  <div id="optIn-settings" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Opt-In Settings</v-toolbar-title>
    </v-toolbar>
        <v-container>
            <v-layout wrap>
                <v-flex lg12 v-for="(item, index) in optInData" :key="index">
                    <div class="theme-options ml-5 mr-5">
                        <v-subheader class="px-1 my-2">
                            {{ item.caption }}
                        </v-subheader>
                        <v-divider></v-divider>
                        <div class="my-3 ml-2">
                            <v-layout row wrap>
                                <v-flex lg12>
                                    <v-switch
                                            label="Do Not Call"
                                            v-model="item.status.doNotCall"
                                            v-if="item.isFourStatus"
                                            @click.native="controlSwitch(item.optInType, 2)"
                                            class="ma-2"
                                            color="#5C82E3"
                                            hide-details
                                    ></v-switch>
                                </v-flex>
                                <v-flex lg12>
                                    <v-switch
                                            label="Uncontactable"
                                            v-model="item.status.uncontactable"
                                            v-if="item.isFourStatus"
                                            @click.native="controlSwitch(item.optInType, 4)"
                                            class="ma-2"
                                            color="#5C82E3"
                                            hide-details
                                    ></v-switch>
                                </v-flex>
                                <v-flex lg12>
                                    <v-switch
                                            label="Marketing Opt-in"
                                            v-model="item.status.isMarketing"
                                            v-if="item.isTwoStatus"
                                            @click.native="controlSwitch(item.optInType, 8)"
                                            class="ma-2"
                                            color="#5C82E3"
                                            hide-details
                                            :disabled="item.optInType === 3 && !item.status.isMarketing"
                                    ></v-switch>
                                </v-flex>
                                <v-flex lg12>
                                    <v-switch
                                            label="Operation Opt-in"
                                            v-model="item.status.isOperation"
                                            v-if="item.isTwoStatus"
                                            @click.native="controlSwitch(item.optInType, 16)"
                                            class="ma-2"
                                            color="#5C82E3"
                                            hide-details
                                            :disabled="item.optInType === 3"
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </div>
                    </div>
                </v-flex>
            </v-layout>

            <v-btn class="ml-6 save-btn" @click="saveOptIn" :loading="isSubmitted" :disabled="isSubmitted">SAVE</v-btn>
        </v-container>
        <template>
          <v-dialog v-model="dialog" @input="handleDialogInput" max-width="600">
            <v-card style="padding: 20px;">
                <v-btn icon @click="closeDialog" class="absolute top-0 right-0">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-card-title style="font-size: 24px; font-weight: 600; color: #161A40; font-family: 'Montserrat';">
                    Home Phone Marketing Opt In
                </v-card-title>

                <v-checkbox
                  v-model="checkboxValue"
                  label="Customer's explicit revocation"
                  required
                  class="ml-8 font-weight-bold"
                ></v-checkbox>

                <v-card-actions class="d-flex">
                  <v-btn class="ml-auto save-btn font-weight-bold" @click="saveCheckBoxValue" :disabled="!checkboxValue">YES</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
    </div>
</template>
<script>
import { LIST_INIT_STRUCTURE } from '@/setting/list-header/list-init-structure'
import { CustomerApi } from '@/api/pandaria'
import { Tool, Popup } from '@/util/index'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'opt-in-setting',
  props: {
    loan: Object
  },
  mounted () {
    this.$eventBus.$on('optInSettings', target => {
      this.getOptInData()
    })
  },
  data () {
    return {
      optInData: JSON.parse(JSON.stringify(LIST_INIT_STRUCTURE.OPT_IN_SETTING)),
      isSubmitted: false,
      optInArr: '',
      dialog: false,
      checkboxValue: false
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId () {
      this.getOptInData()
    }
  },
  methods: {
    getOptInData () {
      CustomerApi.getCustomerOptInData({ loanId: this.loanId }, this.getLoanOptInDataCallBack)
    },
    getLoanOptInDataCallBack (result) {
      if (tool.isNotEmpty(result)) {
        this.optInArr = result
        this.optInData = tool.renderOptIn(this.optInData, result)
        this.$eventBus.$emit('broadcastOptIn', { optInData: this.optInData })
      }
    },
    controlSwitch (optInType, value) {
      this.optInData = tool.controlOptInSwitch(this.optInData, optInType, value)
      console.log(this.optInData)
      if (optInType === 3 && value === 8) {
        this.dialog = true
      }
      this.$forceUpdate()
    },
    saveOptIn () {
      this.isSubmitted = true
      if (tool.isNotEmpty(this.loanId)) {
        const jsonOptIn = tool.getOptInValue(this.optInData)
        const optInData = {
          loanId: this.loanId,
          items: jsonOptIn
        }
        CustomerApi.replaceCustomerOptInData(optInData, this.replaceLoanOptInDataCallBack, this.replaceLoanOptInDataFailureCallBack)
      }
    },
    saveCheckBoxValue () {
      this.dialog = false
    },
    handleDialogInput (value) {
      if (!value) {
        this.optInData[2].status.isMarketing = true
        this.checkboxValue = false
      }
    },
    replaceLoanOptInDataCallBack () {
      this.getOptInData()
      this.isSubmitted = false
      popup.popupForSuccess('Success')
    },
    replaceLoanOptInDataFailureCallBack (result) {
      this.isSubmitted = false
      popup.popupForWarning(result.message)
    },
    closeDialog () {
      this.dialog = false
      this.checkboxValue = false
      this.optInData[2].status.isMarketing = true
    }
  }
}
</script>
<style scoped>
  .toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none;
  }
  .save-btn {
    color: #5C82E3;
    background: #DEE6F9 !important;
    border-radius: 2px;
    height: 24px !important;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-transform: none;
    font-family: 'Montserrat';
    padding: 0 8px !important;
    box-shadow: none;
    margin-top: 16px;
  }
  .v-btn.absolute.top-0.right-0 {
    position: absolute;
    top: 10px;
    right: 10px;
  }
</style>
